import React, { useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { commonInspectionObservationColor } from "common/constant";
import Chart from "Components/Common/Chart";

const CommonInspectionsBarChart = ({ chartData, t }) => {
  const initialOption = {
    chart: {
      type: "bar",
      stacked: true,
    },
    colors: commonInspectionObservationColor,
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      categories: [],
      labels: {
        formatter: function (val) {
          const maxLength = 18;
          return val?.length > maxLength
            ? val.slice(0, maxLength) + "..."
            : val;
        },
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    yaxis: {
      title: {
        text: undefined,
      },
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "left",
      offsetX: 40,
    },
    tooltip: {
      enabled: true,
      shared: false,
      x: {
        formatter: function (value) {
          return value;
        },
      },
      y: {
        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
          const remarks =
            w.globals.initialSeries[seriesIndex].remarks[dataPointIndex];
          return `${value} ${remarks ? `( ${remarks} )` : ""}`;
        },
      },
    },
  };

  const [data, setData] = useState([]);
  const [remarks, setRemarks] = useState([]);
  const [options, setOptions] = useState(initialOption);

  const series = useMemo(
    () => [
      {
        name: "Common Inspection Observations",
        data: data,
        remarks: remarks,
      },
    ],
    [data, remarks]
  );

  useEffect(() => {
    const barChartLabels = chartData.map((x) => x.category);
    const barChartData = chartData.map((x) => x.count);
    const barChartRemarks = chartData.map((x) => x.remarks ?? "");
    setRemarks(barChartRemarks);
    setData(barChartData);
    setOptions((prev) => ({
      ...prev,
      xaxis: { ...prev.xaxis, categories: barChartLabels },
    }));
  }, [chartData]);

  return (
    <Chart
      key={remarks}
      title={t("Common Inspection Observations")}
      options={options}
      series={series}
      height={350}
      type="bar"
    />
  );
};

CommonInspectionsBarChart.propTypes = {
  chartData: PropTypes.array,
  t: PropTypes.func,
};

export default withTranslation()(CommonInspectionsBarChart);
